import React from "react";
import { Container } from "@prestosports/commons-ui";
import PlayerList from "../components/PlayerList";

const PlayerListContainer = ({
	team,
	onRowAction,
	onSelectionChanged,
	selectedPlayerIds,
	onPageChanged,
	currentPage,
	onSortChanged,
	sortField,
	sortDirection,
	playerType
}) => {
	return (
		<Container fullHeight noPaper>
			<PlayerList
				team={team}
				onRowAction={onRowAction}
				onSelectionChanged={onSelectionChanged}
				selectedPlayerIds={selectedPlayerIds}
				onPageChanged={onPageChanged}
				currentPage={currentPage}
				onSortChanged={onSortChanged}
				sortField={sortField}
				sortDirection={sortDirection}
				playerType={playerType}
			/>
		</Container>
	);
};

export default PlayerListContainer;
